export const ACCOUNT_EVENTS = {
  PROFILE_MENU_OPENED: "Profile Menu Opened",
  SIGNOUT_CLICKED: "Sign Out Clicked",
};